const uniqueValuesSplitOnSpaces = ({ input })=>{
    return new Set(input.split(' ').map((val)=>val.trim()).filter((val)=>val.length > 0));
};

export { uniqueValuesSplitOnSpaces };
//# sourceMappingURL=uniqueValuesSplitOnSpaces.mjs.map
